import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import SoundAssetKeys from '../SoundAssetKeys';

export default class StateButton extends Phaser.GameObjects.Image {
  /**
   * 
   * @param {Phaser.Scene} scene
   */
  constructor(scene,sprite1, sprite2) {
    super(scene,0,0,ABCyaPhaser.Images.DEFAULT_ATLAS, sprite1);

    this.enabled = true;

    this.buttonSprite1 = sprite1;
    this.buttonSprite2 = sprite2;

    this.setInteractive();

    this.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.doClick, this);

    this.doAction1 = () => {};
    this.doAction2 = () => {};
  }

  doClick () {
    if (!this.enabled) { return; }

    if (this.frame.name === this.buttonSprite1) {
      this.setFrame(this.buttonSprite2);
      this.doAction1();
    }
    else {
      this.setFrame(this.buttonSprite1);
      this.doAction2();
    }

    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this.scene);

    const baseScale = this.scale;

    // make button shrink and expand to react to click
    ABCyaPhaser.Tweens.addTween(this, 70, { scale: 0.8 * baseScale, yoyo: true }, Phaser.Math.Easing.Linear);
  }

  switchStateOff () {
    this.setFrame(this.buttonSprite2);
  }
}